import styled, { css } from 'styled-components';
import { Typography } from '../../../global/theme';
import { mobile_xl, mobile_xs } from '../../../global/mediaQueryMixin';
import { AlignCenter, FlexBetween, FlexCenter, HideScrollbar, LineClamp } from '../../../global/commonStyle';
interface Props {
  isSearch?: boolean;
  color?: string;
  isKeyboardVisible?: boolean;
  isOtherProjectList?: boolean;
}
const Group = styled.div`
  max-width: 1022px;
  margin: auto;
  height: 100dvh;
  position: relative;
  ${HideScrollbar}
  padding-inline: var(--space-24);
  ${mobile_xl(css`
    padding-inline: var(--space-20);
  `)}
`;

const Content = styled.div<Props>`
  display: flex;
  flex-direction: column;
  gap: var(--space-20);
  ${mobile_xl(css<Props>`
    padding-block: var(--space-8)
      ${({ isKeyboardVisible }) => (isKeyboardVisible ? 'var(--space-20 )' : 'var(--space-96)')};
    gap: var(--space-24);
  `)}
`;

const Icon = styled.div`
  cursor: pointer;
  ${FlexCenter}
  padding: var(--space-4);
  &.favorite-icon {
    display: none;
  }
  &:hover {
    background-color: var(--background-muted);
    border-radius: var(--border-radius-4);
    svg {
      filter: brightness(var(--brightness-value2));
    }
    .star-icon {
      path {
        fill: var(--text-primary);
      }
    }
  }
  ${mobile_xl(css`
    &.favorite-icon {
      display: flex;
    }
    padding: var(--space-6);
    svg {
      width: 20px;
      height: 20px;
    }
  `)}
`;

const ProjectItem = styled.div<Props>`
  ${AlignCenter}
  gap: var(--space-40);
  padding: var(--space-16);
  background-color: var(--background-primary);
  border-bottom: 0.5px solid var(--border-primary);
  cursor: pointer;
  &:hover {
    border-bottom: 0.5px solid var(--border-primary);
    background: var(--neutral-secondary);
    ${Icon} {
      display: flex;
    }
    .plus-icon {
      border: 1px solid var(--neutral-secondary);
    }
    .avatar {
      border: 1px solid var(--neutral-secondary);
    }
  }
  :last-child {
    border-bottom: none;
  }

  ${mobile_xl(css`
    gap: var(--space-10);
    position: relative;
    padding: var(--space-12) var(--space-16);
    flex-direction: column;
    align-items: flex-start;
    &:hover {
      .avatar {
        border: 1px solid var(--background-primary);
      }
      .plus-icon {
        border: 1px solid var(--background-primary);
      }
    }
  `)}
`;

const ProjectName = styled.div`
  max-width: 500px;
  width: 100%;
  ${AlignCenter}
  gap: var(--space-16);
  &.admin-project-name {
    max-width: 640px;
  }
  ${mobile_xl(css`
    gap: var(--space-6);
  `)}
`;

const Title = styled.h1`
  ${Typography.body_lg_medium}
  color: var(--text-primary);
  margin: var(--space-0);
  cursor: pointer;
  padding-block: var(--space-2);
  ${LineClamp(1)}
  word-break: break-all;
  ${mobile_xl(css`
    font-weight: 600;
    padding-block: var(--space-0);
  `)}
`;

const Text = styled.p`
  ${Typography.body_md}
  color: var(--text-secondary);
  margin: var(--space-0);
  padding-block: var(--space-2);
  ${LineClamp(1)}
  word-break: break-all;
  ${mobile_xl(css`
    padding-block: var(--space-0);
  `)}
`;

const Point = styled.div`
  max-width: 180px;
  width: 100%;
  position: relative;
  border: none;
  ${AlignCenter}
  gap: var(--space-6);
  ${mobile_xl(css`
    max-width: unset;
    padding-left: var(--space-6);
  `)}
`;

const SmallDiv = styled.small<Props>`
  position: absolute;
  border-radius: var(--border-radius-full);
  background-color: ${(props: Props) => props.color};
  top: 3px;
  width: 10px;
  height: 10px;
  left: 0px;
  ${mobile_xl(css`
    top: 5px;
  `)}
`;

const ProgressStatus = styled.span`
  position: relative;
  ${Typography.body_sm}
  color: var(--text-primary);
  padding-left: var(--space-16);
`;

const AssignGroup1 = styled.div`
  width: 100%;
  ul {
    display: flex;
    flex-wrap: nowrap;
    list-style-type: none;
    padding: var(--space-0);
    margin: var(--space-0);
    justify-content: flex-end;
  }
  li {
    margin-left: -10px;
  }
  small {
    padding: var(--space-5);
    border-radius: var(--border-radius-full);
    background: var(--text-secondary);
    border: 2px solid var(--background-primary);
  }
  span {
    ${Typography.body_xs_semibold}
    color: var(--text-primary);
  }
  .plus-icon {
    width: 20px;
    height: 20px;
    border-radius: var(--border-radius-full);
    ${FlexCenter}
    color: var(--text-primary);
    background-color: var(--background-muted);
    ${Typography.body_xs_semibold}
    border: 1px solid var(--background-primary);
    position: relative;
    top: 0;
    z-index: var(--z-index-base);
  }
  ${mobile_xl(css`
    max-width: unset;
    width: max-content;
    &.admin-assign {
      margin-left: var(--space-8);
      ul {
        justify-content: flex-start;
      }
    }
    ul {
      justify-content: flex-end;
    }
    .plus-icon {
      width: 22px;
      height: 22px;
      padding-bottom: var(--space-0);
      border: 1px solid var(--background-primary);
    }
  `)}
`;

const TopContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-8);
`;
const BottomContent = styled.div`
  display: flex;
  flex-direction: column;
`;
const ProjectList = styled.div<Props>`
  border: 0.5px solid var(--border-primary);
  border-radius: var(--border-radius-12);
  background-color: var(--background-secondary);
  margin-bottom: var(--space-20);
  overflow: hidden;
  ${mobile_xl(css<Props>`
    margin-bottom: ${({ isOtherProjectList }) => (isOtherProjectList ? 'var(--space-0)' : 'var(--space-20)')};
  `)}
`;
const TitleText = styled.div`
  color: var(--text-primary);
  ${Typography.body_lg_medium}
`;

const LoadingState = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-20);
`;
const Div = styled.div`
  display: flex;
  gap: var(--space-8);
  ${mobile_xl(css`
    width: 100%;
    justify-content: space-between;
    gap: var(--space-8);
    align-items: center;
  `)}
`;
const EmptyBox = styled.div`
  ${FlexCenter}
  padding-block: var(--space-36);
  background: var(--background-primary);
  border: 0.5px solid var(--border-primary);
  border-radius: var(--border-radius-12);
  margin-bottom: var(--space-12);
`;
const ShowHideText = styled.div<Props>`
  ${Typography.body_md}
  color: var(--text-secondary);
  text-align: center;
  padding-bottom: var(--space-20);
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  span {
    text-decoration: underline;
    cursor: pointer;
  }
  ${mobile_xl(css<Props>`
    line-height: 20px;
    padding-bottom: ${({ isOtherProjectList }) => (isOtherProjectList ? 'var(--space-20)' : 'var(--space-0)')};
  `)}
`;
const RightDiv = styled.div`
  ${AlignCenter}
  gap: var(--space-40);
  ${mobile_xl(css`
    flex-direction: column;
    gap: var(--space-6);
    align-items: flex-start;
  `)}
`;

const BottomHeader = styled.div`
  ${FlexBetween}
  gap: var(--space-8);
  padding-bottom: var(--space-8);
  ${mobile_xl(css`
    padding-bottom: var(--space-8);
  `)}
`;

const FilterDiv = styled.div`
  ${AlignCenter}
  gap: var(--space-8);
  .active {
    background-color: var(--neutral-secondary);
    border-radius: var(--border-radius-8);
  }
`;

const SearchArea = styled.div<Props>`
  position: relative;
  ${AlignCenter}
  width: ${(props) => (props.isSearch ? '200px' : '26px')};
  transition: width var(--transition-slow) ease;
  height: 26px;
  /* search icon css  */
  .search-icon {
    position: absolute;
  }
  .search-icon-active {
    position: absolute;
    top: 1px;
    left: 2px;
    cursor: unset;
    &:hover {
      background-color: transparent;
    }
    svg path {
      fill: var(--text-primary);
    }
  }
  .search-close-icon {
    position: absolute;
    right: 4px;
    top: 3px;
  }
  ${mobile_xs(css<Props>`
    width: ${(props) => (props.isSearch ? '164px' : '26px')};
  `)}
`;

const InputArea = styled.input<Props>`
  width: ${(props) => (props.isSearch ? '100%' : '0')};
  border-radius: var(--border-radius-6);
  border: 0.5px solid var(--brand-primary);
  padding: ${(props) => (props.isSearch ? 'var(--space-5) var(--space-32)' : 'var(--space-0)')};
  ${Typography.body_sm}
  animation: width 0.5s;
  outline: none;
  background: var(--background-primary);
  color: var(--text-primary);
`;

const MoreOptionSection = styled.div`
  ${AlignCenter}
  justify-content: end;
  gap: var(--space-20);
  max-width: 140px;
  width: 100%;
  .active {
    background-color: var(--background-muted);
    border-radius: var(--border-radius-4);
  }
  .more-icon:hover {
    background-color: var(--background-muted);
  }
  ${mobile_xl(css`
    max-width: 75px;
    width: max-content;
    ${AlignCenter}
    justify-content: flex-end;
  `)}
`;
const JoinButtonSection = styled.div`
  ${AlignCenter}
  justify-content: end;
  gap: var(--space-20);
  width: 100%;
  ${mobile_xl(css`
    max-width: 100%;
    justify-content: flex-start;
  `)}
`;

const MiddleDiv = styled.div`
  ${AlignCenter}
  justify-content: flex-end;
  gap: var(--space-40);
  width: 100%;
  max-width: 360px;
  &.admin-project {
    max-width: 170px;
    justify-content: flex-end;
  }
  ${mobile_xl(css`
    max-width: unset;
    padding-left: var(--space-40);
    gap: var(--space-20);
    justify-content: space-between;
    align-items: center;
    width: -webkit-fill-available;
  `)}
`;

const TitleSection = styled.div`
  width: 100%;
  ${AlignCenter}
  gap: var(--space-8);
  /* classname is given for avatar text */
  .project-title {
    span {
      ${Typography.body_lg_semibold}
    }
  }
  ${mobile_xl(css`
    gap: var(--space-10);
    .project-title {
      padding-block: var(--space-4) var(--space-6);
    }
  `)}
`;

const DivLeftSection = styled.div`
  width: calc(100% - 24px);
  ${AlignCenter}
  gap: var(--space-8);
  &.admin-project {
    width: 100%;
  }
  ${mobile_xl(css`
    flex-direction: column;
    align-items: flex-start;
    gap: var(--space-2);
  `)}
`;
const DivRightSection = styled.div`
  width: 24px;
  ${AlignCenter}
  gap: var(--space-8);
  ${mobile_xl(css`
    width: max-content;
  `)}
`;

export {
  Group,
  Content,
  ProjectItem,
  ProjectName,
  Icon,
  Title,
  Text,
  Point,
  AssignGroup1,
  BottomContent,
  TopContent,
  ProjectList,
  TitleText,
  LoadingState,
  Div,
  EmptyBox,
  ShowHideText,
  RightDiv,
  BottomHeader,
  FilterDiv,
  SearchArea,
  InputArea,
  MoreOptionSection,
  MiddleDiv,
  JoinButtonSection,
  TitleSection,
  DivLeftSection,
  DivRightSection,
  SmallDiv,
  ProgressStatus
};
